import { defineMessages } from 'react-intl-next';
export var imageBorderMessages = defineMessages({
  borderColor: {
    id: 'fabric.editor.imageBorderColor',
    defaultMessage: 'Color',
    description: 'Change the border color of an image.'
  },
  borderColorDropdownAriaLabel: {
    id: 'fabric.editor.imageBorderColor.dropdownAriaLabel',
    defaultMessage: 'Image border options Color dropdown',
    description: 'ARIA label for the dropdown to change the border color of an image.'
  },
  borderSize: {
    id: 'fabric.editor.imageBorderSize',
    defaultMessage: 'Size',
    description: 'Change the border size of an image.'
  },
  borderSizeDropdownAriaLabel: {
    id: 'fabric.editor.imageBorderSize.dropdownAriaLabel',
    defaultMessage: 'Image border options Size dropdown',
    description: 'ARIA label for the dropdown to change the border size of an image.'
  },
  addBorder: {
    id: 'fabric.editor.addImageBorder',
    defaultMessage: 'Add border',
    description: 'Add a border to an image.'
  },
  removeBorder: {
    id: 'fabric.editor.removeImageBorder',
    defaultMessage: 'Remove border',
    description: 'Remove the border of an image.'
  },
  borderOptions: {
    id: 'fabric.editor.imageBorderOptions',
    defaultMessage: 'Border options',
    description: 'Display options available for customizing the border of an image.'
  },
  borderSizeSubtle: {
    id: 'fabric.editor.imageBorderSubtle',
    defaultMessage: 'Subtle',
    description: 'Name of a border size.'
  },
  borderSizeMedium: {
    id: 'fabric.editor.imageBorderMedium',
    defaultMessage: 'Medium',
    description: 'Name of a border size.'
  },
  borderSizeBold: {
    id: 'fabric.editor.imageBorderBold',
    defaultMessage: 'Bold',
    description: 'Name of a border size.'
  }
});